import {authMiddleware} from "./loginAction";
import cfg, {handleResponse, handlePrepareData, formatStatusError} from "../constants";

// triggersAction - get triggers
export const triggersAction = (filter, signal) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/flow-list', { // Updated endpoint
        method: "POST",
        body: JSON.stringify(filter),
        headers,
        signal
    }).then(handleResponse).then(handlePrepareData);
};

// triggerGetAction - get trigger by ID
export const triggerGetAction = (id) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/flow/' + id, { // Updated endpoint
        method: "GET",
        headers
    }).then(handleResponse).then((data) => {
        if (data.status === 'ok') {
            return data.item; // Updated to reflect trigger
        }
        if (data.errors && data.errors.length > 0) {
            throw new Error(data.errors[0]);
        }
        throw new Error('error_other');
    });
};

// triggerDeleteAction - delete trigger by ID
export const triggerDeleteAction = (id) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/flow/' + id, { // Updated endpoint
        method: "DELETE",
        headers
    }).then(handleResponse).then(handlePrepareData);
};

// triggerEditAction - edit trigger profile
export const triggerEditAction = (item) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/flow', {
      method: "POST",
      headers,
      body: JSON.stringify(item)
    }).then(handleResponse).then(handlePrepareData);
  };

// triggerActiveAction - change trigger activity
export const triggerActiveAction = (id) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/flow-active/' + id, {
      method: "GET",
      headers
    }).then(handleResponse).then(handlePrepareData);
  };

// triggerFileAction - upload trigger file
export const triggerFileAction = (block_id, file) => (dispatch, getState) => {
    const token = authMiddleware(dispatch, getState, false, true);
    return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("file", file, file.name);
        formData.append("block_id", block_id);

        const req = new XMLHttpRequest();
        req.addEventListener("load", event => {
            if (req.status === 200) {
                try {
                    let data = JSON.parse(req.response);
                    if (data.status === 'ok') {
                        resolve({id: data.id, name: data.name});
                    } else if (data.errors && data.errors.length > 0) {
                        reject(new Error(data.errors[0]));
                    } else {
                        reject(new Error('error_other'));
                    }
                } catch (e) {
                    reject(new Error('error_other'));
                }
            } else {
                reject(formatStatusError(req.status));
            }
        });

        req.upload.addEventListener("error", event => {
            reject(req.response);
        });

        req.open("POST", cfg.base_url + '/ba/flow-upload');
        req.setRequestHeader("Authorization", 'Bearer ' + token);
        req.send(formData);
    });
  };

  
// flowSessionsAction - get flow sessions
export const flowSessionsAction = (filter) => (dispatch, getState) => {
    const headers = authMiddleware(dispatch, getState);
    return fetch(cfg.base_url + '/ba/flow-session', {
      method: "POST",
      body: JSON.stringify(filter),
      headers
    }).then(handleResponse).then(handlePrepareData);
  };